define('formatDate/formatDate',['require','exports','module'],function( require, exports ){
    var 
	months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	full_months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	dows = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	full_dows = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	//Spanish Dates
	months_es = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
	full_months_es = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	dows_es = ["dom", "lun", "mar", "mi&eacute;", "jue", "vie", "s&aacute;b"],
	full_dows_es = ["domingo", "lunes", "martes", "mi&eacute;rcoles", "jueves", "viernes", "s&aacute;bado"];


	var dateFormats = {
		ShortDate: "MM/dd/yyyy",
		FullDateTime: "EEEE, dd MMMM yyyy HH:mm:ss",
		YMD: "yyyyMMdd"
	};

	var DATE = "date";


	//Formats Date according to patterns
	/*
		@date - date object to format
		@mask - string mask to use for formatting
		@utc - string "UTC:" forces all dates to UTC values
		@es - boolean flag that if set to "true" will convert all week and month values to spanish
	*/
	exports.formatDate = function () {
		var	token = /d{1,2}|E{3,4}|M{1,4}|yy(?:yy)?|([HhmsAa])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
			timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
			timezoneClip = /[^-+\dA-Z]/g,
			pad = function (v) {
				return((v<10)?"0":"")+v;
			};
			
		// Regexes and supporting functions are cached through closure
		return function (date, mask, utc, es) {		
			// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
			if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
				mask = date;
				date = undefined;
			}

			// Passing date through Date applies Date.parse, if necessary
			date = date ? new Date(date) : new Date();
			if (isNaN(date)) throw new SyntaxError("invalid date");

			mask = String(dateFormats[mask] || mask || dateFormats.FullDateTime);

			// Allow setting the utc argument via the mask
			if (mask.slice(0, 4) == "UTC:") {
				mask = mask.slice(4);
				utc = true;
			}

			var	_ = utc ? "getUTC" : "get",
				d = date[_ + "Date"](),
				E = date[_ + "Day"](),
				M = date[_ + "Month"](),
				y = date[_ + "FullYear"](),
				H = date[_ + "Hours"](),
				m = date[_ + "Minutes"](),
				s = date[_ + "Seconds"](),
				S = date[_ + "Milliseconds"](),
				o = utc ? 0 : date.getTimezoneOffset(),
				flags = {
					d:    d,
					dd:   pad(d),
					EEE:  (es)?dows_es[E]:dows[E],
					EEEE: (es)?full_dows_es[E]:full_dows[E],						
					M:    M + 1,
					MM:   pad(M + 1),
					MMM:  (es)?months_es[M]:months[M],
					MMMM: (es)?full_months_es[M]:full_months[M],						
					yy:   String(y).slice(2),
					yyyy: y,
					h:    H % 12 || 12,
					hh:   pad(H % 12 || 12),
					H:    H,
					HH:   pad(H),
					m:    m,
					mm:   pad(m),
					s:    s,
					ss:   pad(s),							
					S:    pad(S > 99 ? Math.round(S / 10) : S),
					a:    H < 12 ? "am" : "pm",					
					A:    H < 12 ? "AM" : "PM",
					Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
					o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
					P:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
				};

			return mask.replace(token, function ($0) {
				return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
			});
		};
	}();

	//To custom format
	exports.toCustomFormat = function(dtObj, dateFormat) {
		if($.type(dtObj) === DATE) {
			return exports.formatDate(dtObj, dateFormat);
		}
	};

	//To short date
	exports.toShortDate = function(dtObj) {
		if($.type(dtObj) === DATE) {
			return exports.formatDate(dtObj, dateFormats.ShortDate);
		}
	};
	//To YMD format (i.e. 20080101)
	exports.toYMD = function(dtObj) {
		if($.type(dtObj) === DATE) {
			return exports.formatDate(dtObj, dateFormats.YMD);
		}
	};
});

